import { useContext } from 'react'
import { ToastContext, type ToastContextValue } from './ToastContext'

/**
 * Toast を表示・解除するための hook。`<ToastProvider>` の子孫から呼ぶこと。
 * Provider 外で呼ぶと **開発者エラーとして即座に throw** する (silent failure を避ける)。
 *
 *   const { show, dismiss } = useToast();
 *   show({ tone: 'success', titleKey: 'common.toast.copy_done' });
 */
export const useToast = (): ToastContextValue => {
  const ctx = useContext(ToastContext)
  if (ctx === null) {
    throw new Error('useToast must be called within a <ToastProvider>')
  }

  return ctx
}
